export enum EnumAssetScheme {
	'IMAGE' = 'image',
	'VIDEO' = 'video',
	'AUDIO' = 'audio',
	'DOCUMENT' = 'document',
	'PRESENTATION' = 'presentation',
	'OTHER' = 'other',
}
